import { create } from 'zustand';

interface DataSourcesModalState {
  counter: number;
  opened: boolean;
  gbaseModalOpened: boolean;
  setCounter: (value: number) => void;
  onOpen: () => void;
  onClose: () => void;
  openGbaseModal: () => void;
  closeGbaseModal: () => void;
}

export const useDataSourcesModal = create<DataSourcesModalState>((set) => ({
  counter: 0,
  opened: false,
  gbaseModalOpened: false,
  setCounter: (value) => set({ counter: value }),
  onOpen: () => set({ opened: true }),
  onClose: () => set((state) => ({ counter: state.counter + 1, opened: false })),
  openGbaseModal: () => set({ gbaseModalOpened: true }),
  closeGbaseModal: () => set({ gbaseModalOpened: false }),
}));
